// extracted by mini-css-extract-plugin
var _1 = "NC44Rs0CTo";
var _2 = "pWYo9c1p3G";
var _3 = "X8blXgLP9h";
var _4 = "Bl5i8Guvoq";
var _5 = "iu6Z_P5Q89";
var _6 = "_LiPGXOtAF";
var _7 = "n26Ww1YCGs";
var _8 = "zT6m8OuYM0";
var _9 = "E1i4gY9dId";
var _a = "txqgCM3KIq";
var _b = "zJp9DCBlHg";
var _c = "jWUXD6TfLq";
var _d = "vCWXyPeDiD";
var _e = "gOby6L5CmE";
export { _1 as "accuracy", _2 as "complexity", _3 as "frame", _4 as "headerText", _5 as "hist_h", _6 as "hist_m", _7 as "hist_r", _8 as "keyLabel", _9 as "lighterFrame", _a as "normalText", _b as "speed", _c as "subheaderText", _d as "threshold", _e as "valueLabel" }
